import { render, staticRenderFns } from "./SparePartsImage.vue?vue&type=template&id=b5970b10&"
import script from "./SparePartsImage.vue?vue&type=script&lang=js&"
export * from "./SparePartsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports